var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('BackArrow'),_c('v-row',{staticClass:"justify-center text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('AddBook')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }